import React, { Component } from "react";
import {
  withStyles,
  Card,
  CardHeader,
  Avatar,
  Typography,
  CardContent,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  CardActions,
  Button,
} from "@material-ui/core";
import Add from "@material-ui/icons/Add";

import Snack from "../../Snackbar/Snack";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { GetData, DeleteData, PutData } from "../../../api/service";
import FileUpload from "../../AddNew/FileUpload";

const styles = (theme) => ({
  textField: {
    width: "100%",
  },
  formControl: {
    width: "100%",
    marginTop: theme.spacing.unit * 2,
  },
});

class EditNewFacility extends Component {
  state = {
    id: "",
    group_name: "",
    index1: "",
    open: false,
    message: "",
    edit: false,
  };

  __loadData() {
    let data = this.props.history.location.state;
    console.log(data)
    this.setState({
      ...data,
      edit: true,
      isLoaded: true,
    });
  }

  componentDidMount() {
    this.__loadData()
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.__loadData();
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onSubmit = (e) => {
    e.preventDefault();

    let data = {
      ...this.state,
    };

    //console.log(data);

    PutData(
      `/${this.props.apikey}/${this.state.id}/editiqacfilegroup`,
      data
    ).then((resp) => {
      //console.log(resp)
      this.setState({
        open: true,
        message: resp,
      });
    });
  };

  deleteNotice = () => {
    let id = this.state.id;

    confirmAlert({
      title: "Confirm to delete",
      message: "Are you sure to do this.",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.confirmDeleteNotice(id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  confirmDeleteNotice = (id) => {
    DeleteData(`/${this.props.apikey}/${id}/deleteiqacfilegroup`)
      .then((resp) => {
        console.log(resp);
        this.setState({
          open: true,
          message: resp,
        });
      })
      .then(() => {
        this.props.history.replace("/filegroup/view");
      });
  };

  render() {
    let { classes } = this.props;
    return (
      <div>
        {this.state.open ? (
          <Snack
            open={this.state.open}
            handleClose={() => {
              this.setState({
                open: false,
                message: "",
              });
            }}
            message={this.state.message}
          />
        ) : null}
        <form onSubmit={this.onSubmit}>
          <Card>
            <CardHeader
              avatar={
                <Avatar>
                  <Add />
                </Avatar>
              }
              title={<Typography variant="h6">Edit File Group</Typography>}
            />
            <CardContent>
              <Grid container spacing={24}>
                <Grid item lg={12} sm={12}>
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Group Name"
                    fullWidth
                    multiline
                    rowsMax="4"
                    name="group_name"
                    value={this.state.group_name}
                    onChange={this.handleChange}
                    variant="outlined"
                  />
                </Grid>

                <Grid item lg={12} sm={12}>
                  <TextField
                    id="outlined-multiline-flexible"
                    label="Order"
                    fullWidth
                    multiline
                    rowsMax="4"
                    name="index1"
                    value={this.state.index1}
                    onChange={this.handleChange}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </CardContent>

            <CardActions>
              <Button variant="outlined" color="primary" type="submit">
                Update
              </Button>

              <Button
                variant="outlined"
                color="primary"
                type="button"
                onClick={this.deleteNotice}
              >
                Delete
              </Button>
            </CardActions>
          </Card>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(EditNewFacility);



// WEBPACK FOOTER //
// ./src/Components/Iqac/Facility/EditIqacFileGroup.js